import {AxiosResponse} from 'axios'
import {AlbumTagStatsRequest, AlbumTagStatsResponse} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface GetAlbumTagStats<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

// Fetches per-album person-tag counts (facial-recognition tags, unique persons
// among them, and manual tags), scoped to published photos. Backed by the photos
// service's GetAlbumTagStats endpoint, which enforces the authoritative
// `campminderstaff` gate server-side and 403s non-staff callers.
export const getAlbumTagStats: GetAlbumTagStats<
  AlbumTagStatsRequest,
  AlbumTagStatsResponse
> = (http, params) => {
  const {ClientID, AlbumID} = params

  const path = `/v1/photos/albums/${AlbumID}/tag-stats`

  return http.request<AlbumTagStatsResponse>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}`,
  })
}
